// Shared react-loading-skeleton color themes, tuned to the site's palette
// (see tailwind.config.js) instead of the library's gray default.
//
// `lightSkeletonTheme` is for skeletons sitting on white/cream sections
// (accent-cream, white cards). `darkSkeletonTheme` is for skeletons sitting
// on the primary-dark sections (hero, value strip, story band) and uses a
// translucent white so it reads against any dark gradient.
export const lightSkeletonTheme = {
  baseColor: "#e4e1f2",
  highlightColor: "#f5f3fb",
};

export const darkSkeletonTheme = {
  baseColor: "rgba(255, 255, 255, 0.13)",
  highlightColor: "rgba(255, 255, 255, 0.26)",
};
